(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  const SECTION_ID = 'cart-drawer';

  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-cart-dialog]');
      this.bindEvents();

      // Any control anywhere can open the drawer.
      document.addEventListener('click', (event) => {
        if (event.target.closest('[data-cart-open]')) {
          event.preventDefault();
          this.open();
        }
      });

      // Intercept every add-to-cart form so quick-add in the grid and the
      // product page both land in the drawer without a page reload.
      document.addEventListener('submit', (event) => {
        const form = event.target;
        if (!form.matches('form[action*="/cart/add"]')) return;
        event.preventDefault();
        this.addFromForm(form);
      });
    }

    bindEvents() {
      this.querySelector('[data-cart-close]')?.addEventListener('click', () => this.close());

      this.querySelectorAll('[data-cart-quantity]').forEach((button) => {
        button.addEventListener('click', () => {
          this.change(Number(button.dataset.line), Number(button.dataset.cartQuantity));
        });
      });

      // Clicking the backdrop means clicking the dialog itself, since the
      // panel covers the whole element.
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
    }

    open() {
      if (!this.dialog.open) this.dialog.showModal();
    }

    close() {
      if (this.dialog.open) this.dialog.close();
    }

    async addFromForm(form) {
      const submitButton = form.querySelector('[type="submit"]');
      submitButton?.setAttribute('disabled', '');

      const body = new FormData(form);
      body.append('sections', SECTION_ID);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body,
        });
        const data = await response.json();

        if (!response.ok) {
          this.reportError(form, data.description || data.message);
          return;
        }

        this.render(data.sections?.[SECTION_ID]);
        this.open();
      } catch (error) {
        // Fall back to a normal form post so the shopper is never stuck.
        form.submit();
      } finally {
        submitButton?.removeAttribute('disabled');
      }
    }

    async change(line, quantity) {
      this.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity, sections: SECTION_ID }),
        });
        const data = await response.json();
        this.render(data.sections?.[SECTION_ID]);
      } catch (error) {
        window.location.href = '/cart';
      } finally {
        this.removeAttribute('aria-busy');
      }
    }

    render(html) {
      if (!html) return;

      // Swap only the panel: replacing the whole section would recreate the
      // dialog element and drop its open state mid-interaction.
      const fresh = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('[data-cart-contents]');

      if (fresh) {
        this.querySelector('[data-cart-contents]').replaceWith(fresh);
        this.bindEvents();
      }

      this.updateCount();
    }

    async updateCount() {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      document.querySelectorAll('[data-cart-count]').forEach((element) => {
        element.textContent = cart.item_count;
        element.hidden = cart.item_count === 0;
      });

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    }

    reportError(form, message) {
      const target = form.querySelector('[data-cart-error]');
      if (target) target.textContent = message;
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  class DiscountForm extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-discount-input]');
      this.button = this.querySelector('[data-discount-apply]');

      this.button.addEventListener('click', () => this.apply());
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.apply();
        }
      });
    }

    apply() {
      const code = this.input.value.trim();
      if (!code) return;

      // /discount/CODE applies the code to the session and follows the
      // redirect, which is the only supported way to do this from a theme.
      window.location.href = `/discount/${encodeURIComponent(code)}?redirect=/checkout`;
    }
  }

  if (!customElements.get('discount-form')) {
    customElements.define('discount-form', DiscountForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Auto-submit the facet form so filtering feels immediate. The noscript
  // button covers the case where this never runs.
  document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('facet-form');
    if (!form) return;

    form.addEventListener('change', () => form.submit());

    // The sort select lives outside the form element, linked by the `form`
    // attribute, so its change event needs wiring up separately.
    const sort = document.getElementById('sort-by');
    if (sort && !form.contains(sort)) {
      sort.addEventListener('change', () => form.submit());
    }

    // The filter panel ships `open` (visible on desktop and without JS). Close
    // it on mobile, where it should collapse behind the "Filtros" toggle, and
    // keep the two states in sync as the viewport crosses 990px.
    const disclosure = document.querySelector('.facets__disclosure');
    if (disclosure) {
      const desktop = window.matchMedia('(min-width: 990px)');
      const sync = () => {
        disclosure.open = desktop.matches;
      };
      sync();
      desktop.addEventListener('change', sync);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.main = this.querySelector('.gallery__image');

      this.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => this.select(thumb));
      });
    }

    select(thumb) {
      if (!this.main) return;

      // Swap src and drop srcset, or the browser keeps serving the old
      // candidate list and the image never changes.
      this.main.src = thumb.dataset.full;
      this.main.removeAttribute('srcset');
      this.main.alt = thumb.dataset.alt || '';

      this.querySelectorAll('[data-gallery-thumb]').forEach((item) => {
        item.removeAttribute('aria-current');
      });
      thumb.setAttribute('aria-current', 'true');
    }

    // Show the image assigned to a variant, by its media id, reusing the same
    // swap as a thumb click. No-op when the variant has no image or the gallery
    // has no matching thumb (e.g. a single-image product).
    selectByMediaId(id) {
      if (id == null) return;
      const thumb = this.querySelector(`[data-gallery-thumb][data-media-id="${id}"]`);
      if (thumb) this.select(thumb);
    }
  }

  class VariantPicker extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('[data-variant-data]');
      this.variants = data ? JSON.parse(data.textContent) : [];

      // Isolated so a bad price map can never take the rest of the picker
      // (availability, cart id, URL) down with it.
      this.prices = {};
      const prices = this.querySelector('[data-variant-prices]');
      if (prices) {
        try {
          this.prices = JSON.parse(prices.textContent);
        } catch (error) {
          console.error('variant price map failed to parse', error);
        }
      }

      // Variant id -> assigned image media id, so a selection can swap the
      // gallery to that variant's photo. Isolated like the price map.
      this.media = {};
      const media = this.querySelector('[data-variant-media]');
      if (media) {
        try {
          this.media = JSON.parse(media.textContent);
        } catch (error) {
          console.error('variant media map failed to parse', error);
        }
      }

      this.gallery = document.querySelector('product-gallery');

      this.form = this.closest('form');

      // Price and stock live in the info column, outside the form, so reach
      // for them from the shared ancestor rather than the form.
      const info = this.closest('.product__info');
      this.priceEl = info ? info.querySelector('.product__price') : null;
      this.stockEl = info ? info.querySelector('.product__stock') : null;

      this.addEventListener('change', () => this.onChange());
      this.updateAvailability();

      // Products with more than 250 variants come through truncated, because
      // Liquid caps product.variants at 250. Pull the complete list so the
      // variants past that cap can be selected and added to cart.
      if (this.dataset.truncated) {
        this.loadAllVariants();
      }
    }

    async loadAllVariants() {
      const url = this.dataset.url;
      if (!url) return;

      // Liquid and the .js endpoint both cap variants at 250. The variant-data
      // section paginates past that, so walk its pages via the Section Rendering
      // API and stitch the full list together.
      const MAX_PAGES = 40; // safety bound (10,000 variants)
      const all = [];

      try {
        for (let page = 1; page <= MAX_PAGES; page++) {
          const response = await fetch(`${url}?section_id=variant-data&page=${page}`);
          if (!response.ok) break;

          const markup = await response.text();
          const doc = new DOMParser().parseFromString(markup, 'text/html');

          const data = doc.querySelector('[data-variants-page]');
          if (!data) break;
          for (const v of JSON.parse(data.textContent)) all.push(v);

          const flag = doc.querySelector('[data-has-next]');
          if (!flag || flag.dataset.hasNext !== 'true') break;
        }

        if (all.length === 0) return;

        this.variants = all.map((v) => ({
          id: v.id,
          options: v.options,
          available: v.available,
          price: v.price,
          compare_at_price: v.compareAt,
          featuredMediaId: v.media,
        }));

        // Re-evaluate with the full set: reveal valid values that were hidden
        // while truncated and resolve a selection that was unreachable before.
        this.updateAvailability();
        this.onChange();
      } catch (error) {
        // Keep the server-rendered subset on any failure.
        console.error('variant pages failed to load', error);
      }
    }

    get selectedOptions() {
      return Array.from(this.querySelectorAll('input:checked')).map((input) => input.value);
    }

    findVariant(options) {
      return this.variants.find((variant) =>
        options.every((value, index) => variant.options[index] === value)
      );
    }

    // Size leads: when the chosen colour has no variant for the selected size,
    // switch to the first colour that does so a size click always resolves.
    // Returns true when it changed the selection.
    selectValidColorForSelection() {
      const colorInput = this.querySelector('.variant-picker__input[data-collapsible="true"]');
      if (!colorInput) return false;
      const colorPos = Number(colorInput.dataset.optionPosition) - 1;
      const selected = this.selectedOptions;

      const variant =
        this.variants.find(
          (v) =>
            v.available &&
            selected.every((value, index) => index === colorPos || v.options[index] === value)
        ) ||
        this.variants.find((v) =>
          selected.every((value, index) => index === colorPos || v.options[index] === value)
        );
      if (!variant) return false;

      const colorValue = variant.options[colorPos];
      const inputs = this.querySelectorAll(
        `.variant-picker__input[data-option-position="${colorPos + 1}"]`
      );
      const target = Array.from(inputs).find((i) => i.value === colorValue);
      if (target && !target.checked) {
        target.checked = true;
        return true;
      }
      return false;
    }

    onChange() {
      let variant = this.findVariant(this.selectedOptions);
      if (!variant && this.selectValidColorForSelection()) {
        variant = this.findVariant(this.selectedOptions);
      }
      this.updateAvailability();

      if (!variant) {
        this.setUnavailable();
        return;
      }

      this.form.querySelector('[data-variant-id]').value = variant.id;

      const button = this.form.querySelector('[data-add-button]');
      button.disabled = !variant.available;
      button.textContent = button.dataset[variant.available ? 'labelAdd' : 'labelSoldOut'] || button.textContent;

      this.updatePrice(variant);
      this.updateStock(variant);

      if (this.gallery) {
        var mediaId = this.media[variant.id];
        if (mediaId == null) mediaId = variant.featuredMediaId;
        this.gallery.selectByMediaId(mediaId);
      }

      // Keep the URL shareable and the browser history sane.
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    // Swap the displayed price for the chosen variant, keeping the sale/regular
    // markup in step with each variant's own pricing.
    updatePrice(variant) {
      if (!this.priceEl) return;

      // Prefer the server-formatted price; fall back to formatting the cents
      // from the fetched variant for any beyond the 250 the server rendered.
      let info = this.prices[variant.id];
      if (!info && variant.price != null) {
        const money = (cents) =>
          new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(cents / 100);
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        info = {
          price: money(variant.price),
          compareAt: onSale ? money(variant.compare_at_price) : '',
          onSale: onSale,
        };
      }
      if (!info) return;

      if (info.onSale) {
        this.priceEl.innerHTML =
          '<span class="product__price-sale"></span> <s class="product__price-compare"></s>';
        this.priceEl.querySelector('.product__price-sale').textContent = info.price;
        this.priceEl.querySelector('.product__price-compare').textContent = info.compareAt;
      } else {
        this.priceEl.textContent = info.price;
      }
    }

    updateStock(variant) {
      if (!this.stockEl) return;
      this.stockEl.classList.toggle('product__stock--in', variant.available);
      this.stockEl.classList.toggle('product__stock--out', !variant.available);
      this.stockEl.textContent = variant.available
        ? this.dataset.inStock
        : this.dataset.outOfStock;
    }

    setUnavailable() {
      const button = this.form.querySelector('[data-add-button]');
      button.disabled = true;
    }

    // Reflect, for every option value, whether it leads to a real variant.
    //
    // The leading option (the small set, e.g. sizes) dominates: a size is
    // clickable whenever ANY variant has it, regardless of the colour chosen —
    // so sizes never strike out just because the current colour doesn't come in
    // that size. The subordinate option (the large set marked data-collapsible,
    // e.g. 170+ colours) is filtered to the chosen size: colours with no
    // variant for it are hidden, leaving only the valid ones. The checked value
    // is never hidden, so a selection stays visible.
    updateAvailability() {
      const selected = this.selectedOptions;

      this.querySelectorAll('.variant-picker__input').forEach((input) => {
        const position = Number(input.dataset.optionPosition) - 1;
        const collapsible = input.dataset.collapsible === 'true';
        const label = input.nextElementSibling;

        let match;
        if (collapsible) {
          // Subordinate: valid for the current selection with this value swapped
          // in (i.e. this colour for the selected size).
          const candidate = [...selected];
          candidate[position] = input.value;
          match = this.variants.find((variant) =>
            candidate.every((value, index) => variant.options[index] === value)
          );
        } else {
          // Dominant: clickable if any variant has this value at all. Prefer an
          // available one so a size only strikes out when it is truly gone.
          match =
            this.variants.find((v) => v.options[position] === input.value && v.available) ||
            this.variants.find((v) => v.options[position] === input.value);
        }

        const unavailable = !match || !match.available;

        if (collapsible) {
          const show = Boolean(match) || input.checked;
          input.hidden = !show;
          if (label) {
            label.hidden = !show;
            label.dataset.unavailable = unavailable;
          }
        } else {
          input.hidden = false;
          if (label) {
            label.hidden = false;
            label.dataset.unavailable = unavailable;
          }
        }
      });
    }
  }

  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.field = this.querySelector('.quantity-input__field');

      this.querySelectorAll('[data-step]').forEach((button) => {
        button.addEventListener('click', () => {
          const next = Number(this.field.value) + Number(button.dataset.step);
          this.field.value = Math.max(Number(this.field.min || 1), next);
          this.field.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }
  if (!customElements.get('variant-picker')) {
    customElements.define('variant-picker', VariantPicker);
  }
  if (!customElements.get('quantity-input')) {
    customElements.define('quantity-input', QuantityInput);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  class RelatedProducts {
    static init() {
      const container = document.querySelector('[data-related]');
      if (!container || container.children.length > 0) return;

      fetch(container.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const fresh = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-related]');

          if (fresh) container.innerHTML = fresh.innerHTML;
        })
        .catch(() => {
          // A failed recommendation fetch should leave the page as it was.
        });
    }
  }

  document.addEventListener('DOMContentLoaded', () => RelatedProducts.init());

  } catch(e) { console.error(e); }
})();
})();
